(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("slide-show", [], factory);
	else if(typeof exports === 'object')
		exports["slide-show"] = factory();
	else
		root["slide-show"] = factory();
})(window, function() {
return 